/* Castle Gothic - strona produktu
   1. Brak preselekcji rozmiaru: blokuje "Dodaj do koszyka" i szybką płatność, dopóki klient nie wybierze opcji
      oznaczonych data-cg-required (snippets/variant-button.liquid). Pokazuje komunikat błędu.
   2. Aktualizuje cenę w przycisku i znaczek -% po zmianie wariantu.
   Nie zmienia logiki motywu - działa na zdarzeniach (capture) przed handlerami Impulse. */
(function () {
  if (window.cgPdpReady) return;
  window.cgPdpReady = true;

  function missingFieldset(form) {
    var sets = form.querySelectorAll('fieldset[data-cg-required]');
    for (var i = 0; i < sets.length; i++) {
      if (!sets[i].querySelector('input:checked')) return sets[i];
    }
    return null;
  }

  function showError(form, fs) {
    var err = form.querySelector('[data-cg-error]');
    var wrap = fs.closest('.variant-wrapper') || fs;
    wrap.classList.add('cg-invalid');
    if (err) {
      err.textContent = fs.getAttribute('data-cg-msg') || '';
      err.hidden = false;
    }
    var r = wrap.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 80) {
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var first = fs.querySelector('input:not(.disabled)') || fs.querySelector('input');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  function guard(e, form) {
    if (!form || !form.classList.contains('cg-pdp-form')) return;
    var fs = missingFieldset(form);
    if (!fs) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    showError(form, fs);
  }

  // Dodaj do koszyka (submit formularza)
  document.addEventListener('submit', function (e) { guard(e, e.target); }, true);

  // Szybka płatność Shopify (przycisk w formularzu)
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var pay = t.closest('.shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout');
    if (!pay) return;
    guard(e, pay.closest('form'));
  }, true);

  function sectionIdOf(form) {
    return (form.id || '').replace('AddToCartForm-', '');
  }

  function refreshPrice(form) {
    var id = sectionIdOf(form);
    var price = document.getElementById('ProductPrice-' + id);
    var atcPrice = form.querySelector('[data-cg-atc-price]');
    if (price && atcPrice) atcPrice.textContent = price.textContent.trim();

    var json = document.getElementById('VariantsJson-' + id);
    var select = document.getElementById('ProductSelect-' + id);
    var pct = document.querySelector('#ProductSection-' + id + ' [data-cg-pct]');
    if (!json || !select || !pct) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    var vid = String(select.value);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === vid) {
        var v = variants[i];
        if (v.compare_at_price && v.compare_at_price > v.price) {
          pct.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          pct.hidden = false;
        } else {
          pct.hidden = true;
        }
        break;
      }
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('.cg-pdp-form');
    if (!form) return;
    var wrap = t.closest('.variant-wrapper');
    if (wrap) wrap.classList.remove('cg-invalid');
    if (!missingFieldset(form)) {
      form.classList.add('is-chosen');
      var err = form.querySelector('[data-cg-error]');
      if (err) err.hidden = true;
    }
    // po handlerach motywu (aktualizacja ceny i wariantu)
    setTimeout(function () { refreshPrice(form); }, 0);
  });
})();
